export function convertNumber(value: number): {
  intoCurrency: string
  intoNormalAmount: string
} {
  return {
    intoCurrency: value.toLocaleString(),
    intoNormalAmount: value.toLocaleString("ID-id")
  }
}